import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Menu } from 'src/app/@shared/models/menu.model';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ClienteService } from 'src/app/services/cliente/cliente.service';
import { MenuItemsService } from 'src/app/services/menu-items/menu-items.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { ModalPesquisaMenuComponent } from '../header/modal-pesquisa-menu/modal-pesquisa-menu.component';
import { MatSnackBar } from '@angular/material/snack-bar';
//import { ModalPerfilComponent } from '../header/modal-perfil/modal-perfil.component';

@Component({
  selector: 'app-header-sem-menu',
  templateUrl: './header-sem-menu.component.html',
  styleUrls: ['./header-sem-menu.component.scss']
})
export class HeaderSemMenuComponent implements OnInit {

  public usuario = StorageService.getPerfilUsuario();
  public customCollapsedHeight = '48px';
  public customExpandedHeight = '48px';
  comunicados: any[];
  company: any = {};
  user: any = {};
  alerts: any;
  habilitarPesquisa: boolean = false;

  menuItems = [];
  clientId = null;
  cliente: any = {};

  constructor(
    public clienteService: ClienteService,
    public authService: AuthService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public dialog: MatDialog,
    public menu: MenuItemsService,
    public snackBar: MatSnackBar
  ) { }

  searchForm = new FormGroup({
    search: new FormControl()
  })
  get search() { return this.searchForm.get('search').value }

  ngOnInit() {
    this.authService
      .checkFeature(`cadastro.home-vesta.pesquisa-menu`)
      .subscribe((temPermissao) => {
        if (temPermissao === true) this.habilitarPesquisa = true;
      });
    this.getUserPermissions();
    //console.log(this.usuario);

  }

  private getUserPermissions() {
    this.menu.getMenus().subscribe(
      (response: Menu[]) => this.menuItems = response,
      (error: HttpErrorResponse) => {
        console.error(error);
      });
  }

  public abrirModalPesquisa(items: Menu[]) {
    if (!this.search) {
      return this.openSnackBar("O campo de pesquisa não pode ser vazio!", 'OK', 5000, 'danger-snackbar');
    }
    const dialogRef = this.dialog.open(ModalPesquisaMenuComponent, {
      width: '650px',
      data: { items: items, search: this.search }
    })
  }

  onlyFirstName(name) {
    return name ? name.replace(/ .*/, '') : '';
  }

  openResponsiveMenu() {
    const menu = document.querySelector('.responsive-menu-content');
    menu.classList.toggle('open');
  }

  logout() {
    this.authService.logout().subscribe(s => {
      this.router.navigate(['/login']).then(() => {
        window.location.reload();
      });
      localStorage.clear();
    });
  }

  abrirModalPerfil() {
    this.usuario = StorageService.getPerfilUsuario();
    // const dialogRef = this.dialog.open(ModalPerfilComponent, {
    //   width: '540px',
    //   minHeight: '275px',
    //   data: {
    //     usuario: this.usuario
    //   },
    // });
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
